import { FunctionComponent, ReactNode, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextSportsHeader from '@contexts/sportsHeader'
import { SportsHeaderContextType } from '@contexts/sportsHeader'

type StyledSportsHeaderWrapperProps = Pick<
  SportsHeaderContextType,
  'teaserType'
>

const { SportsHeaderContext } = contextSportsHeader

const StyledSportsHeaderWrapper = styled.div<StyledSportsHeaderWrapperProps>`
  ${({ teaserType }) =>
    teaserType !== 'toi' &&
    css`
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
    `}
`

const SportsHeaderWrapper: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const { teaserType } = useContext(SportsHeaderContext)
  return (
    <StyledSportsHeaderWrapper teaserType={teaserType}>
      {children}
    </StyledSportsHeaderWrapper>
  )
}

export default SportsHeaderWrapper
